<template>
  <div data-app>
    <div
      role="alert"
      v-bind:class="{ show: errors.length }"
      class="alert fade alert-danger"
    >
      <div class="alert-text" v-for="(error, i) in errors" :key="i">
        {{ error }}
      </div>
    </div>
    <v-card>
      <v-card-title>Prefix Announcements</v-card-title>
      <v-data-table
        v-model="selected"
        :loading="loading"
        :headers="headers"
        :items="diversions"
        :search="search"
        item-key="subnet"
        class="elevation-1"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn color="primary" dark class="mb-2" v-on="on"
                  >Manual Announcement</v-btn
                >
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">New Announcement</span>
                </v-card-title>

                <v-card-text>
                  <v-form ref="newForm" lazy-validation>
                    <v-container>
                      <v-row dense>
                        <v-col cols="12">
                          <v-text-field
                            v-model="editedItem.subnet"
                            label="Subnet*"
                            :rules="ipRules"
                            required
                          />
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-form>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="close"
                    >Cancel</v-btn
                  >
                  <v-btn color="blue darken-1" text @click="save">Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon v-if="item.manual" small @click="deleteItem(item)"
            >mdi-delete</v-icon
          >
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import api from "@/common/api.service";
import Errors from "@/common/errors";
import ipAddr from "ip-address";

export default {
  mounted() {
    api
      .query("diversions")
      .then(
        (response) =>
          (this.diversions = response.data.diversions.map((row) => ({
            ...row,
            reason: row.manual ? "Manual diversion" : "Host under attack",
          })))
      )
      .catch((error) => this.errors.push(...Errors.extractErrorMessage(error)))
      .finally(() => (this.loading = false));
  },

  data: () => ({
    selected: [],
    headers: [
      { text: "Subnet", align: "left", value: "subnet" },
      { text: "Reason", value: "reason" },
      { text: "Readvertised", value: "readvertised" },
      { text: "Actions", value: "actions", sortable: false },
    ],
    diversions: [],
    errors: [],
    loading: true,
    dialog: false,
    editedItem: {
      subnet: null,
    },
    search: "",
    ipRules: [
      (v) => {
        if (!v) return "IP subnet is required";

        if (!v.endsWith("/22") && !v.endsWith("/23") && !v.endsWith("/24")) return "Subnet between /22 and /24 required";

        let ipv4 = new ipAddr.Address4(v);
        if (ipv4.isValid()) return true;

        let ipv6 = new ipAddr.Address6(v);
        if (ipv6.isValid()) return true;

        return "Valid subnet between /22 and /24 required";
      },
    ],
  }),

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  methods: {
    deleteItem(item) {
      if (confirm("Are you sure you want to delete this item?")) {
        api.delete("diversions/" + item.subnet).then((response) => {
          const index = this.diversions.indexOf(item);
          this.diversions.splice(index, 1);
        });
      }
    },

    close() {
      this.dialog = false;
    },

    save() {
      if (!this.$refs.newForm.validate()) return;

      let subnet = this.editedItem.subnet;

      api
        .post(`diversions/${subnet}`)
        .then((response) => {
          this.diversions = [
            { subnet, manual: true, reason: "Manual diversion" },
            ...this.diversions,
          ];
        })
        .catch((error) => this.errors.push(...Errors.extractErrorMessage(error)));

      this.close();
    },
  },
};
</script>
